export default __webpack_public_path__ + "static/logo_IS-2014-2020-39f32bc8acfc92f404f36ce3bc22f777.png";